<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{'ICONS' | translate: {Default: 'Icons'} }}</mat-label>
  <mat-select id="appointment-select-icons" [placeholder]="'SELECT_ICONS' | translate: {Default: 'Select Icons'} " [(ngModel)]="selectedIcons" multiple>
    <mat-option *ngFor="let icon of icons" [value]="icon">
      <mat-icon>{{icon}}</mat-icon>
    </mat-option>
  </mat-select>
</mat-form-field>
